import type { PriceRemoteState } from 'Store/price-remote/priceRemote.reducer';
import 'Store/price-remote/priceRemote.reducer';
export const priceRemoteSelector = ({ priceRemote }: { priceRemote: PriceRemoteState }) =>
  priceRemote || {};
